<template>
  <div class="whole-page defult-page">
    <left-page-navigation></left-page-navigation>
    <div class="page-content">
      <page-navigation />
      <div class="wrapp-iterable-content">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import PageNavigation from 'theme/components/Header/Nav'
import LeftPageNavigation from 'theme/components/LeftNavigation/LeftPageNavigation'

export default {
  components: {
    LeftPageNavigation,
    PageNavigation
  }
}
</script>
